import React from 'react';
import { SentimentVeryDissatisfied as SentimentVeryDissatisfiedIcon } from '@material-ui/icons';
import useStyles from './styles';

export default function PageError() {
  const classes = useStyles();

  return (
    <div className={classes.boxLoading}>
      <h1 align="center">
        <SentimentVeryDissatisfiedIcon align="center" fontSize="large" />
        <br />
        Error to get information. Try again later.
      </h1>
    </div>
  );
}
